export default __webpack_public_path__ + "static/media/ajout.fd18ec3c.svg";